/* eslint-disable no-eval */
import { createHook, createStore, defaults } from 'react-sweet-state';

// const logger = (storeState) => (next) => (arg) => {
//   console.log(storeState.key, 'payload: ', arg);
//   const result = next(arg);
//   console.log(storeState.key, ':', storeState.getState());
//   return result;
// };

defaults.devtools = true;
// defaults.middlewares.add(logger);

export const initialState = {
  /**
   * PARAMETROS GENERALES
   */

  showOnlyFormPago: false,
  idPoliza: null,
  codProducto: null,
  detallePago: {},
  catalogo: {},
  datosTarifacion: null,
  loading: true,
  loadingForm: false,
  mediosPago: [],
  subMedios: [],
  isValidandoTarjeta: false,
  isTarjetaValida: true,
  newRoutes: null,

  isPagoRealizado: false,
  medioPagoUsado: null,
  polizaCompletada: false,
  numeroPoliza: null,

  /**
   * PARAMETROS LINK COBRO
   */
  isFromLinkCobro: false,
  tokenCorreo: null,
  sessionId: null,
  from: 'default',
  /**
   * ESTADOS FORMULARIO
   */
  permiteContinuar: true,
  tieneTokenActivo: true,
  isCancelandoToken: false,
  showFormPago: false,
  showFormCancelarTokens: false,
  /**
   * ENVIO DE LINK DE COBRO
   */
  enviandoLinkCobro: false,
};

const actions = {
  setState: (state = {}) => {
    return ({ setState, getState }) => {
      setState({ ...getState(), ...state });
    };
  },
  cancelarTokenCorreo: (state) => {
    return ({ setState, ...rest }) => {
      setState({ isCancelandoToken: state });
    };
  },
  setDetallePago: (detallePago) => {
    return ({ setState }) => {
      setState({ detallePago });
    };
  },

  setDatosTarifacion: (datosTarifacion) => {
    return ({ setState }) => {
      setState({ datosTarifacion });
    };
  },

  setCatalogo: (catalogo) => {
    return ({ setState }) => {
      setState({ catalogo });
    };
  },

  setLoading: (loading) => {
    return ({ setState }) => {
      setState({ loading });
    };
  },

  setLoadingForm: (loadingForm) => {
    return ({ setState }) => {
      setState({ loadingForm });
    };
  },

  setMediosPago: (medios) => {
    return ({ setState }) => {
      setState({ mediosPago: medios.map((item) => ({ ...item, value: item })) });
    };
  },

  setValidandoTarjeta: (isValidandoTarjeta) => {
    return ({ setState }) => {
      setState({ isValidandoTarjeta, loadingForm: isValidandoTarjeta });
    };
  },

  setTarjetaValida: (isTarjetaValida) => {
    return ({ setState }) => {
      setState({ isTarjetaValida });
    };
  },
};

const PagoStore = createStore({
  name: 'PagoPageState',
  initialState: initialState,
  actions: actions,
});

const hook = createHook(PagoStore);

export const usePantallaPago = () => {
  return hook()[0];
};

export const useAccionesPantallaPago = () => {
  return hook()[1];
};
